<div class="well row col-xs-12">
    <div class="row">
        <h3 class="col-xs-12 text-center" [id]="scaleResult.scale.name" >
            <em>{{scaleResult.scale.name}}</em>
            <small><em>Score:</em> {{scaleResult.score}}</small>
        </h3>
        <h4 class="col-xs-12 text-center"><em>Range:</em> {{scaleResult.range.displayName}}</h4>
        <div class="col-xs-12 col-sm-offset-1 col-sm-10 col-md-offset-2 col-md-8">
            <app-scale-chart [scale-result]="scaleResult"></app-scale-chart> 
        </div>
        <div class="col-xs-12" *ngIf="scaleResult?.range?.clientContent" [innerHTML]="scaleResult?.range?.clientContent"></div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/reports/report-items/computed-scale/computed-scale.component.html